export default __webpack_public_path__ + "static/media/3-tablet.a28db185.jpg";